<!-- <ion-button size="small" class="ion-margein" color="danger" (click)="debugShowFormData()"> -->
<!--   debug form | {{formId}} ({{status}}) -->
<!-- </ion-button> -->

<form class="proto-input-form" novalidate
  [formGroup]="editForm"
  [ngClass]="{
    'is-ready': dataReceived,
    'is-disabled': isLoading,
    'is-blocked': isFormContentBlocked() }">

  <div [attr.inert]="isFormContentBlocked() || null">
    @for (list of formFieldLists; let listIndex = $index; track list.id + '-' + listIndex) {
    <!-- don't show the tab buttons on data-review page -->
    @if (status !== 'review-request') {
      <!-- display filter buttons after meta informations -->
      @if (list.id === 'name' && formCategories.length > 1) {
        <div class="form-categories">
          @for (category of formCategories; track category) {
            <ion-button [fill]="selectedCategory === category ? 'solid' : 'outline'" class="proto-button form-category-button"
              (click)="selectedCategory = category">
              {{ ('FORM.CATEGORY.' + category.toUpperCase()) | translate }}
            </ion-button>
          }
        </div>
      }
    }

    @if ((selectedCategory === 'all' || !list.category || list.category === selectedCategory) && listHasVisibleItems(list)) {
      @if (list.type === 'dynamic') {
        @for (item of list.items; track item.id) {
          <div class="proto-list-note proto-list-note--inset proto-list-note--dynamic is-top">{{ item.listLabel | translate }}</div>
          @let control = asFormArray(item.id);
          <proto-dynamic-form-field
            [ngClass]="{ 'is-blocked': isFieldBlocked(item.id) }"
            [attr.inert]="isFieldBlocked(item.id) || null"
            [field]="item"
            [formArray]="control"
            [values]="dynamicFields[item.id]"
            [changedSubForms]="changedSubForms[item.id] || []"
            [changedSubFormFields]="changedSubFormFields[item.id] || []"
            [status]="status"
            [isInSplitView]="isInSplitView"
            (valueUpdated)="onValueUpdated($event, item)"
            (openModal)="openModal($event)"></proto-dynamic-form-field>
        }
      } @else {
        @if (list.title) {
          <div class="proto-list-note proto-list-note--inset is-top">{{ list.title | translate }}</div>
        }
        <ion-list class="proto-input-list" inset>
          @for (item of list.items; let i = $index; track item.id) {
            <!-- dynamic fields are already part of dynamic fieldset -->
            @if (item.type !== 'dynamic') {
              @let control = asFormControl(item.id);
              <proto-form-field
                [attr.inert]="isFieldBlocked(item.id) || null"
                [ngClass]="{
                  'is-blocked': isFieldBlocked(item.id),
                  'data-review-changed': status === 'to-be-reviewed' && changedFields.includes(item.id),
                  'has-visible-hint': status === 'review-request' && item.hintText,
                  'has-badge-buttons': item.type === 'selectModal' && selectedItems[item.id]?.length }"
                [control]="control"
                [field]="item"
                [status]="status"
                (valueUpdated)="onValueUpdated($event, item)"
                (openModal)="openModal($event)"></proto-form-field>

              @if (status === 'to-be-reviewed' && item.id === 'isPublished' && data?.deletionReason && data?.isPublished === false) {
                <ion-item mode="ios" lines="none" class="form-field-item form-field-item--textarea form-field-item--delete-reason {{status}}">
                  <ion-textarea auto-grow="true"
                    [rows]="3"
                    [readonly]="true"
                    [value]="data.deletionReason"></ion-textarea>
                </ion-item>
              }

              @if (item.type === 'selectModal' && selectedItems[item.id]?.length) {
                @if (item.inputType !== 'hidden' && !item.isReadOnly) {
                  <div class="select-modal-badge-buttons">
                    @for (selectedItem of selectedItems[item.id]; track selectedItem.id) {
                      <ion-button class="select-modal-badge-button" mode="ios" size="small" color="medium-secondary"
                        (click)="removeItemFromSelectModal(item.id, selectedItem.displayName)">
                        {{selectedItem.displayName }} <ion-icon name="close-outline" slot="end"></ion-icon>
                      </ion-button>
                    }
                  </div>
                }
              }
            }
          }
        </ion-list>
      }
    }
    }
  </div>

  <div class="footer-content" [class.footer-content--static]="status === 'review-request'">
    @if (status === 'to-be-reviewed') {
      <h2 class="footer-content__title">{{ 'VIEW.ORGANIZATION_FORM.CONFIRM_INFO.TITLE' | translate }}</h2>
      <small class="footer-content__description">{{ 'VIEW.ORGANIZATION_FORM.CONFIRM_INFO.DESCRIPTION' | translate }}</small>
    }

    @if (status === 'review-request') {
      <div class="review-request-container">
        <h2 class="footer-content__title">{{ 'VIEW.ORGANIZATION_DATA_REVIEW.DELETE_DATASET.TITLE' | translate }}</h2>
        <small class="footer-content__description">{{ 'VIEW.ORGANIZATION_DATA_REVIEW.DELETE_DATASET.DESCRIPTION' | translate }}</small>
        <ion-checkbox mode="md"
          [(ngModel)]="reviewRequestDeleteDataset"
          [ngModelOptions]="{standalone: true}"
          (ionChange)="editForm.markAsDirty()"
          class="proto-checkbox delete-dataset-checkbox"
          labelPlacement="end"
          justify="start">
          <div class="ion-text-wrap proto-checkbox-label"
            [innerHTML]="'VIEW.ORGANIZATION_DATA_REVIEW.DELETE_DATASET.CHECKBOX' | translate"
            handle-external-links></div>
        </ion-checkbox>

        @if (reviewRequestDeleteDataset) {
          <ion-item lines="none" mode="ios" class="form-field-item form-field-item--textarea form-field-item--delete-reason is-required">
            <ion-textarea auto-grow="true"
              [rows]="3"
              [(ngModel)]="reviewRequestDeletionReason"
              [ngModelOptions]="{standalone: true}"
              (ionInput)="editForm.markAsDirty()"
              [placeholder]="('VIEW.ORGANIZATION_DATA_REVIEW.DELETE_DATASET.REASON_PLACEHOLDER' | translate) + '*'"/>
          </ion-item>
        }

        <h2 class="footer-content__title">{{ 'VIEW.ORGANIZATION_DATA_REVIEW.SUBMIT.TITLE' | translate }}</h2>
        @for (_ of reviewRequestConditions; let i = $index; track i) {
          <ion-checkbox mode="md"
            [(ngModel)]="reviewRequestConditions[i]"
            [ngModelOptions]="{standalone: true}"
            (ionChange)="editForm.markAsDirty()"
            class="proto-checkbox"
            labelPlacement="end"
            justify="start">
            <div class="ion-text-wrap proto-checkbox-label"
              [innerHTML]="('VIEW.ORGANIZATION_DATA_REVIEW.SUBMIT.CHECKBOX.' + i) | translate"
              handle-external-links></div>
          </ion-checkbox>
        }
      </div>
    }

    @if (status !== 'accepted' && status !== 'denied') {
      <div class="footer-content__buttons">
        <!-- cancel or deny button -->
        @if (status === 'to-be-reviewed') {
          <ion-button class="proto-button" fill="outline" color="danger"
            [disabled]="formInteractionsDisabled"
            (click)="submit(true)">
            {{ 'BUTTON.DENY' | translate }}
          </ion-button>
        } @else if (status !== 'review-request') {
          <ion-button class="proto-button" fill="outline" color="dark"
            [skipDialog]="!editForm.valid && !editForm.dirty"
            (confirm)="processCompleted.emit('canceled')">
            {{ 'BUTTON.CANCEL' | translate }}
          </ion-button>
        }

        <!-- submit button -->
        @if (formFieldLists.length) {
          <ion-button class="proto-button"
            [disabled]="formInteractionsDisabled || !formIsValid()"
            (click)="submit()">
            @if (status === 'new') {
              {{ 'BUTTON.CREATE' | translate }}
            } @else if (status === 'edit') {
              {{ 'BUTTON.SAVE' | translate }}
            } @else {
              {{ 'BUTTON.CONFIRM' | translate }}
            }
          </ion-button>
        }
      </div>
    }
  </div>
</form>
